<template>
	<core-layout-content medium>
		<!-- Headline -->
		<core-layout-headline-and-actions>
			<template slot="headline">
				{{ $t("my_account") }}
			</template>
		</core-layout-headline-and-actions>

		<!-- Page -->
		<account-detail />

		<!-- Modals -->
		<router-view />
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CrmSubmenu from "@/components/CrmSubmenu/"
import AccountDetail from "../components/AccountDetail"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CrmSubmenu,
		AccountDetail
	},

	props: {
		// From router
		id: {
			type: String
		},
		// From router
		section: {
			type: String,
			default: "profile"
		}
	},

	data() {
		return {
			submenu: [
				// {
				//   name: this.$t("my_profile"),
				//   to: `/${this.$route.params.tenantId}/account/detail`
				// }
			]
		}
	}
}
</script>
